"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationEventType_1 = require("../../NotificationEvent/NotificationEventType");
var DataOverwriteRemoteVideoRequestHandler_1 = __importDefault(require("../../RemoteUIManager/handlers/DataOverwriteRemoteVideoRequestHandler"));
var RemoteUIManager_1 = __importDefault(require("../../RemoteUIManager/RemoteUIManager"));
var RemoteUIRequest_1 = __importDefault(require("../../RemoteUIManager/requests/RemoteUIRequest"));
var RemoteUIRequestType_1 = require("../../RemoteUIManager/requests/RemoteUIRequestType");
var LocalStorageSessionManager_1 = __importDefault(require("../../SessionManager/LocalStorageSessionManager"));
/**
 *
 */
var VideoObserver = /** @class */ (function () {
    function VideoObserver() {
        /**Manejador de UI remoto */
        this.remoteUIManager = new RemoteUIManager_1.default(new DataOverwriteRemoteVideoRequestHandler_1.default(new LocalStorageSessionManager_1.default()));
    }
    /**Manejador de UI remoto */
    /*private remoteUIManager: IRemoteUIManager = new RemoteUIManager(
      new RemoteVideoRequestHandler(new LocalStorageSessionManager())
    );*/
    //Remote UI Manager
    VideoObserver.prototype.getRemoteUIManager = function () {
        return this.remoteUIManager;
    };
    /**
     * El tipo de notificacion que va a manejar
     */
    VideoObserver.prototype.getHandledType = function () {
        return NotificationEventType_1.NotificationEventType.VIDEO;
    };
    /**
     * Maneja la notificacion
     * @param iframeWidget
     * @param notificationEvent
     */
    VideoObserver.prototype.handle = function (iframeWidget, notificationEvent) {
        var remoteUIRequest = new RemoteUIRequest_1.default(iframeWidget, notificationEvent, RemoteUIRequestType_1.RemoteUIRequestType.VIDEO);
        this.getRemoteUIManager().manage(remoteUIRequest);
    };
    return VideoObserver;
}());
exports.default = VideoObserver;
